export default {
  lookingLocal: {
    fieldName: 'lookingLocalAddress'
  }
}
